import { Component, OnInit, inject } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UpperCasePipe } from '@angular/common';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { ShopService } from '@app/shared/services/shop.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';
import { WalletComponent } from '@app/shared/components/wallet/wallet.component';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-not-enough',
  templateUrl: './not-enough-modal.component.html',
  styleUrls: ['./not-enough-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent, UpperCasePipe, TranslateModule, SharedModule, WalletComponent, NavigationButtonComponent],
})
export class NotEnoughModalComponent implements OnInit {
  private eventManager = inject(EventManager);
  private translateService = inject(TranslateService);
  private shopService = inject(ShopService);
  loggerService = inject(LoggerService);
  private eventsRepo = inject(EventsRepository);
  notEnoughModalData = inject<Modal>(MAT_DIALOG_DATA);

  componentDestroy: () => Observable<unknown>;

  event: LimitedTimeEvent;
  lang: string;

  ngOnInit(): void {
    this.event = this.eventsRepo.getEventById(this.notEnoughModalData?.data?.eventId);
    this.lang = this.translateService.currentLang;
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.NotEnoughModalComponent, ModalType.View));
  }

  openShopGems(): void {
    this.shopService.openShop(
      'Gems',
      new Modal(
        NonPersistedModalName.NotEnoughModalComponent,
        ModalType.View,
        {},
        '',
        this.notEnoughModalData.deleteModal
      )
    );
  }
}
